module.exports = __webpack_public_path__ + "static/media/image4.9f3e2b81.jpg";